import React from 'react';
import { hasAdministrationRights } from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';

interface Props {
  eventFormStore: EventFormStore;
  readOnly: boolean;
  onCancelEvent?: () => void;
}

const EventCancelEventButtonTw: React.FC<Props> = ({ eventFormStore, readOnly, onCancelEvent }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event) return null;

  const canCancel = () => hasAdministrationRights(event) && event.status.toString() !== 'Completed' && event.status.toString() !== 'Closed';

  if (!canCancel()) return null;

  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      disabled={!readOnly}
      onClick={onCancelEvent}
    >
      Cancel Event
    </button>
  );
};

export default EventCancelEventButtonTw;
